import React from 'react';
import styled from 'styled-components';

const StyledContainer = styled.div`
  padding: 30px 50px;
  @media (max-width: 768px) {
    padding: 30px 15px;
  }
`;

const Container = ({ children }) => {
  return <StyledContainer className="container">{children}</StyledContainer>;
};

export default Container;
